export function catalogueMenu() {
    let triggerBtns = document.querySelectorAll('[data-menu_src]');
    let catalogueMenuEl = document.querySelector('[data-catalogue_menu_nav]');
    let panel = document.querySelector('[data-mainnavcontent="recreation"]');

    let outsideMenuClickListener = (evt) => {
        if (!catalogueMenuEl.contains(evt.target) && !panel.contains(evt.target)) {
            closeMenu();
        }
    }

    function openMenu() {
        catalogueMenuEl.classList.add('active');
        setTimeout(() => {
            document.addEventListener('click', outsideMenuClickListener);
        }, 100);
    }

    function closeMenu() {
        catalogueMenuEl.classList.remove('active');
        document.removeEventListener('click', outsideMenuClickListener);
    }

    triggerBtns.forEach(btn => {
        btn.addEventListener('click', openMenu);
    })
}
